import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const adminsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.ADMINS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ADMINS_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };
    case actions.ADMINS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    
    case actions.ADMIN_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.ADMIN_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.ADMIN_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
  
    case actions.ADMIN_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.ADMIN_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.ADMIN_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singleAdminReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.ADMIN_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.ADMIN_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.ADMIN_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { adminsReducer, singleAdminReducer };
